<template>
  <div class="analysis">
    <AppBar />
    <div class="page-content">
      <div class="page-canvas">
        <div class="por-container">
          <div class="page-info">
            <div class="page-info-title">
                BI分析平台
            </div>
          </div>
        </div>
      </div>
      <div class="analysis-navigation-wrap">
        <div class="navigation-content">
          <div class="navigation-title">助力企业精准人才决策</div>
          <div class="analysis-navigation-list">
            <div
              v-for="(item, index) in navigationList"
              :key="index"
              :class="['navigation-item', navigationIndex == index ? 'check-item' : '']"
              @click="check(index)"
            >
              <div class="list-item-icon-wrap">
                <img :src="item.icon" alt="" class="img"/>
                <img :src="item.logo" alt="" class="check-img"/>
              </div>
              <div class="list-item-title">
                {{ item.title }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="navigationList.length != 0" :key="navigationIndex" class="analysis-content">
        <div class="content-title">
          {{navigationList[navigationIndex].title}}
        </div>
        <div class="content-description">
          {{navigationList[navigationIndex].description}}
        </div>
        <div class="content" v-html="navigationList[navigationIndex].content">
            {{ navigationList[navigationIndex].content }}
        </div>
      </div>
    </div>
    <RightFixedgt />
    <FootWrap />
    <AltProduct ref="altProduct" />
    <ast ref="ast" />
  </div>
</template>

<script>
import { getContentList, getContentDetail } from '@/api/content'
export default {
  name: 'AnalysisView',
  data() {
    return {
      navigationIndex: 0,
      navigationList: [],
    }
  },
  mounted() {
    this.getPageColumn();
  },
  methods: {
    // 获取页面栏目
    async getPageColumn() {
      var params = { columnId: '1610159579956731904', pageNum: 1, pageSize: 10, };
      var { result } = await getContentList(params)

    //   this.navigationList = result.data
      for (var i = 0; i < result.data.length; i++) {
        var navigation = result.data[i]
        var res = await getContentDetail(navigation.id);
        var rrsult = res.result;
        if(rrsult.defaultContent){
            var doc = new DOMParser().parseFromString(rrsult.defaultContent, 'text/html');
            navigation.content = doc.documentElement.textContent.replace(/&nbsp;/g, ' ');
        } else {
            navigation.content = ''
        }
        this.navigationList.push(navigation)
      }
    //   .then((res) => {
    //     const { result, } = res;

    //   });
    },

    check(index) {
      this.navigationIndex = index;
    },
    openBealter () {
      this.$refs.altProduct.tobealter();
    },
    openBealter2() {
       this.$refs.ast.drawer  = true
    },
  },
}
</script>

<style lang="less" scoped>
.analysis{
  background-color: #fff;
  position: relative;
  .page-content{
    width: 100%;
    .page-canvas{
      width: 100%;
      height: 360px;
      min-width: var(--minwidth);
      background: url('@/assets/analysis/canvas.png') no-repeat;
      background-size: cover;
      background-position: center;
      .por-container{
        width: 70%;
        min-width: var(--minwidth);
        height: 100%;
        margin: 0 auto;
        position: relative;
        .page-info{
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          box-sizing: border-box;
          .page-info-title{
            font-family: OPPOSans-R;
            color: #fff;
            font-size: 36px;
            font-weight: 300;
            line-height: 1;
          }
        }
      }
    }
    .analysis-navigation-wrap{
      width: 1200px;
      margin: 0 auto;
      .navigation-content{
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
          .navigation-title{
            font-family: OPPOSans-M;
            font-size: 32px;
            color: #21252b;
            margin-top: 80px;
            margin-bottom: 65px;
          }
          .analysis-navigation-list{
            width: 1160px;
            height: 113px;
            background-image: linear-gradient(
                #f6f6f6 0,
                #ffffff 100%
            );
            box-shadow: 0px 8px 29px 0px rgba(133, 173, 170, 0.11);
            margin-bottom: 70px;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: space-evenly;
            .navigation-item{
              width: 64px;
              display: flex;
              flex-direction: column;
              align-items: center;
              cursor: pointer;
              .list-item-icon-wrap{
                width: 64px;
                height: 64px;
                border-radius: 50%;
                display: flex;
                justify-content: center;
                align-items: center;
                background-color: #fff;
                margin-bottom: 10px;
                .img{
                  display: block;
                }
                .check-img{
                  display: none;
                }
              }
              .list-item-title{
                font-family: OPPOSans-R;
                color: #21252b;
                font-size: 14px;
                line-height: 1;
              }
              &:hover{
                .list-item-icon-wrap{
                  width: 64px;
                  height: 64px;
                  background-image: linear-gradient(180deg, 
                      #ffffff 0%,
                      #f6f9fa 100%);
                  box-shadow: 0px 8px 29px 0px rgba(133, 173, 170, 0.15);
                  border-image-source: linear-gradient(0deg, 
                      #fefeff 0%, 
                      #ffffff 100%);
                  .img{
                    display: none;
                  }
                  .check-img{
                    display: block;
                  }
                }
                .list-item-title{
                    color: #00b0dc;
                }
              }
            }
            .check-item{
                .list-item-icon-wrap{
                  width: 64px;
                  height: 64px;
                  background-image: linear-gradient(180deg, 
                      #ffffff 0%,
                      #f6f9fa 100%);
                  box-shadow: 0px 8px 29px 0px rgba(133, 173, 170, 0.15);
                  border-image-source: linear-gradient(0deg, 
                      #fefeff 0%, 
                      #ffffff 100%);
                  .img{
                    display: none;
                  }
                  .check-img{
                    display: block;
                  }
                }
                .list-item-title{
                    color: #00b0dc;
                }
            }
          }
      }
    }
    .analysis-content{
      width: 1200px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      .content-title{
        font-size: 32px;
        font-family: OPPOSans-M;
        color: #21252b;
        margin-bottom: 20px;
      }
      .content-description{
        font-size: 16px;
        font-family: OPPOSans-R;
        color: #5c6066;
      }
      .content{
        width: 100%;
        margin-top: 50px;
        margin-bottom: 90px;
      }
    }
  }
}
</style>
